import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function SetPinDialog({ open, onOpenChange, onDone }) {
  const [pin, setPin] = useState("");
  const [pin2, setPin2] = useState("");
  const save = async () => {
    if (pin !== pin2) return toast.error("PINs do not match");
    try {
      await api.post("/me/pin", { pin });
      toast.success("Staff PIN saved");
      setPin(""); setPin2("");
      onOpenChange(false);
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="set-pin-dialog">
        <DialogHeader>
          <DialogTitle>Set your staff PIN</DialogTitle>
          <DialogDescription>Required to return to staff mode after handing the device to a patient or after 15 minutes idle. Never share it.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          <Label htmlFor="pin1">New PIN (4-8 digits)</Label>
          <Input id="pin1" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} data-testid="set-pin-input" />
          <Label htmlFor="pin2">Confirm PIN</Label>
          <Input id="pin2" type="password" inputMode="numeric" value={pin2} onChange={(e) => setPin2(e.target.value)} data-testid="set-pin-confirm-input" />
        </div>
        <DialogFooter><Button className="btn-brand" onClick={save} data-testid="set-pin-save-btn">Save PIN</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
